<template>
  <div>
    <TransferenceManagebar />
    <v-container fluid>
      <v-row class="mb-2">
        <v-col cols="12" sm="6" md="2">
          <v-card class="rounded-lg pa-4" elevation="2" style="border-left: 5px solid #455A64">
            <div class="text-overline grey--text">รายการทั้งหมด</div>
            <div class="text-h5 font-weight-bold">{{ stats.overall.total }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-card class="rounded-lg pa-4" elevation="2" style="border-left: 5px solid #2E7D32">
            <div class="text-overline grey--text">บันทึกแล้ว</div>
            <div class="text-h5 font-weight-bold success--text">{{ stats.overall.saved }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <v-card class="rounded-lg pa-4" elevation="2" style="border-left: 5px solid #A86400">
            <div class="text-overline grey--text">รอดำเนินการ</div>
            <div class="text-h5 font-weight-bold warning--text">{{ stats.overall.pending }}</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg pa-4" elevation="2" style="border-left: 5px solid #607D8B">
            <div class="text-overline grey--text">ตัดอัตรา/เกลี่ยอัตรา (ไม่มีตำแหน่งว่างรองรับ)</div>
            <div class="text-h5 font-weight-bold">{{ quotaCutCount }} รายการ</div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg pa-4" elevation="2" style="border-left: 5px solid #F44336">
            <div class="text-overline grey--text">ปลายทางเกษียณปีนี้</div>
            <div class="text-h5 font-weight-bold error--text">{{ retiringDestCount }} รายการ</div>
          </v-card>
        </v-col>
      </v-row>

      <base-material-card
        icon="mdi-clipboard-text"
        title="ข้อมูลสรุปผลการประมวลผลการย้าย"
        class="px-5 py-3"
      >
        <v-row align="center">
          <v-col cols="12" sm="3" md="2">
            <v-select
              v-model="times_select"
              :items="time_ss"
              label="ครั้งที่"
              dense
              outlined
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <v-select
              v-model="years_select"
              :items="year_ss"
              label="ปี พ.ศ."
              dense
              outlined
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <v-btn
              @click="searchTimeYear"
              color="primary"
              outlined
              :disabled="!times_select || !years_select"
            >
              <v-icon left>mdi-magnify</v-icon>ค้นหารอบนี้
            </v-btn>
          </v-col>
          <v-col cols="12" sm="3" md="2">
            <div class="caption grey--text">
              กำลังแสดงรอบ: {{ times_select }}/{{ years_select }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <div class="text-right">
              <v-btn @click="exportToExcel" color="success" outlined class="mr-2">
                <v-icon left>mdi-file-excel</v-icon>ส่งออก Excel
              </v-btn>
              <v-btn
                @click="openImportOfflineDialog"
                color="purple darken-1"
                outlined
                class="mr-2"
              >
                <v-icon left>mdi-upload</v-icon>นำเข้าข้อมูล (อนุมัตินอกระบบ)
              </v-btn>
              <v-btn @click="approveDirector()" color="success" outlined
                >อนุมัติย้าย</v-btn
              >
            </div>
          </v-col>
        </v-row>
        <v-data-table
          color="success"
          :headers="showHeaders"
          :items="conditons_transfer_successs"
          :search="search"
          :loading="loading"
          :item-class="row_classes"
          disable-pagination
        >
          <template v-slot:top>
            <div>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                single-line
                hide-details
                dense
                filled
                class="mb-2"
              />
            </div>
            <div>
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                label="เลือกคอลัมน์ที่ต้องการแสดง"
                multiple
                outlined
                return-object
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index < 6">
                    <span>{{ item.text }}</span>
                  </v-chip>
                  <span v-if="index === 6" class="grey--text caption"
                    >(+{{ selectedHeaders.length - 6 }} คอลัมน์)</span
                  >
                </template>
              </v-select>
            </div>
          </template>

          <template v-slot:item.actionCencel="{ item }">
            <v-btn
              fab
              small
              v-if="item.ctsstatus_select === 'transfer'"
              @click="CencelMovementCut(item.ctsid_ref)"
              color="warning"
              ><v-icon>mdi-cancel</v-icon></v-btn
            >
            <v-btn
              fab
              small
              v-else
              @click="CencelMovement(item.ctsid_ref)"
              color="warning"
              ><v-icon>mdi-cancel</v-icon></v-btn
            >
          </template>

          <template v-slot:item.college_name_new="{ item }">
            <div
              style="background-color: #81c784;  color: blue;"
              class="text-center ma-1"
            >
              <span
                style="font-size:16px; font-weight: bolder;"
                class="font-weight-bold"
              >
                {{ item.college_name_new }}</span
              >
            </div>
          </template>

          <template v-slot:item.id_branch="{ item }">
            <div>
              <v-chip v-if="item.id_branch" color="success">
                <v-icon>mdi-checkbox-marked-circle</v-icon>
              </v-chip>
            </div>
          </template>

          <template v-slot:item.college_name_old="{ item }">
            <div
              style="background-color: grey; font-weight: bolder; color: yellow;"
              class="text-center"
            >
              <span style="font-size:16px;" class="font-weight-bold">
                {{ item.college_name_old }}</span
              >
            </div>
          </template>

          <template v-slot:item.service_status="{ item }">
            <v-chip v-if="item.service_status === 'service'" color="warning">
              <span style="font-size:16px;"> <v-icon>mdi-check</v-icon></span>
            </v-chip>
          </template>

          <template v-slot:item.demand_college="{ item }">
            <v-chip v-if="item.ctsstatus_select === 'demand'" color="warning">
              <span style="font-size:16px;"> <v-icon>mdi-check</v-icon></span>
            </v-chip>
          </template>

          <template v-slot:item.ctsstatus_select="{ item }">
            <v-chip color="success" dark>
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'demand'"
              >
                ว.ประสงค์รับ</span
              >
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'agree'"
              >
                ปกติ</span
              >
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'transfer'"
              >
                ตัดโอน</span
              >
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'sw_normal'"
              >
                สับเปลี่ยน</span
              >
              <span
                style="font-size:16px;"
                v-if="item.ctsstatus_select === 'sw_agree'"
              >
                (แลกเปลี่ยน)</span
              >
            </v-chip>
          </template>

          <template v-slot:item.verify_flags="{ item }">
            <v-chip
              v-if="item.dest_retire_status === 'retiring_this_year'"
              color="error"
              dark
              small
              class="ma-1"
            >
              <v-icon left small>mdi-alert</v-icon>ปลายทางเกษียณปีนี้ ({{ item.dest_occupant_name }})
            </v-chip>
            <v-chip
              v-if="Number(item.duplicate_position_count) > 0"
              color="warning"
              dark
              small
              class="ma-1"
            >
              <v-icon left small>mdi-content-duplicate</v-icon>ตำแหน่งซ้ำ
            </v-chip>
            <v-chip
              v-if="Number(item.duplicate_card_count) > 1"
              color="warning"
              dark
              small
              class="ma-1"
            >
              <v-icon left small>mdi-account-multiple-remove</v-icon>รายการซ้ำ
            </v-chip>
            <v-chip
              v-if="Number(item.is_status_invalid) === 1"
              color="error darken-2"
              dark
              small
              class="ma-1"
            >
              <v-icon left small>mdi-close-octagon</v-icon>สถานะไม่ถูกต้อง
            </v-chip>
            <v-chip
              v-if="Number(item.is_same_college) === 1"
              color="grey darken-1"
              dark
              small
              class="ma-1"
            >
              สถานศึกษาเดิม=ใหม่
            </v-chip>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
          >
        </v-data-table>
      </base-material-card>

      <!-- V-model canceldialog -->
      <v-layout row justify-center>
        <v-dialog v-model="canceldialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="ยกเลิกรายการ"
              class="px-5 py-3 text_google"
            >
              <div class="text-right"></div>
            </base-material-card>
            <v-card-text>
              <v-form ref="cancelform" lazy-validation>
                {{ conditons_transfer_successs.id_cts }}
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md6>
                      <p>
                        รหัสอ้างอิง :
                        {{ transference_personnels_id_ref.id_ref }}
                      </p>

                      <div class="text--center">
                        รหัสบัตรประชาชน :
                        {{ transference_personnels_id_ref.id_card }}
                        ชื่อ-นามสกุล :
                        {{ transference_personnels_id_ref.title_s
                        }}{{ transference_personnels_id_ref.frist_name }}
                        {{ transference_personnels_id_ref.last_name }}

                        สถานศึกษาปัจจุบัน :
                        {{ transference_personnels_id_ref.college_name }}
                        เลขที่ตำแหน่งปัจจุบัน :
                        {{ transference_personnels_id_ref.id_position }}
                      </div>
                    </v-flex>
                    <v-flex
                      md6
                      v-if="
                        conditons_transfer_successsSelect.ctsstatus_select ===
                          'transfer'
                      "
                    >
                      ตัดโอนตำแหน่ง ไปยัง :
                      {{ conditons_transfer_successsSelect.college_name_new }}
                    </v-flex>
                    <v-flex md6 v-else>
                      <p>
                        รหัสวิทยาลัยปลายทาง :
                        {{ man_powerss.college_code || "" }}
                      </p>
                      <div>
                        วิทยาลัย :
                        {{ man_powerss.college_name || "" }}
                      </div>
                      เลขที่ตำแหน่ง :
                      {{ man_powerss.id_position || "" }}
                    </v-flex>
                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="canceldialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>

              <v-btn
                v-if="
                  conditons_transfer_successsSelect.ctsstatus_select ===
                    'transfer'
                "
                large
                color="warning"
                @click.stop="cancelCutSubmit()"
                rounded
              >
                <v-icon dark>mdi-delete-forever</v-icon>&nbsp;ยืนยัน
              </v-btn>

              <v-btn
                v-else
                large
                color="warning"
                @click.stop="cancelSubmit()"
                rounded
              >
                <v-icon dark>mdi-delete-forever</v-icon>&nbsp;ยืนยัน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- V-model approveDirectordialog -->
      <v-layout row justify-center>
        <v-dialog v-model="approveDirectordialog" persistent max-width="60%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="อนุมัติย้าย ผู้บริหาร"
              class="px-5 py-3 text_google"
            >
              <div class="text-right"></div>
            </base-material-card>
            <v-card-text>
              <v-form ref="approveform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md12>
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="approveUpdate.date_app_now"
                            label="วันที่หนังสือ : "
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="approveUpdate.date_app_now"
                          no-title
                          scrollable
                          locale="th"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu.save(date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12>
                      <v-divider></v-divider>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="approveDirectordialog = false" rounded>
                <v-icon dark>mdi-close</v-icon>ยกเลิก
              </v-btn>

              <v-btn
                large
                color="success"
                @click.stop="approveDirectorSubmit()"
                rounded
              >
                <v-icon dark>mdi-content-save</v-icon>&nbsp;ยืนยัน
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- V-model importOfflineDialog -->
      <v-layout row justify-center>
        <v-dialog v-model="importOfflineDialog" persistent max-width="95%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="purple darken-1"
              icon="mdi-upload"
              title="นำเข้าข้อมูลผู้ย้าย (อนุมัตินอกระบบ)"
              class="px-5 py-3 text_google"
            >
              <div class="text-right"></div>
            </base-material-card>
            <v-card-text>
              <v-alert type="info" text dense class="mt-4">
                ใช้สำหรับกรณีการย้ายดำเนินการนอกระบบทั้งหมด แล้วนำผลที่อนุมัติแล้วเข้าระบบภายหลัง — ระบบจะ
                อัปเดตสังกัด/ตำแหน่งของบุคคลใน personnel_temporary และผู้ครองตำแหน่งใน jor18 ทันที (ไม่แตะ
                man_power) กรุณากด "ตรวจสอบก่อนนำเข้า" และอ่านผลตรวจสอบให้ครบก่อนกด "ยืนยันนำเข้า"
              </v-alert>

              <v-row class="mt-2">
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="importTimeS"
                    :items="time_ss"
                    label="ครั้งที่"
                    outlined
                    dense
                    :disabled="importBusy"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select
                    v-model="importYearS"
                    :items="year_ss"
                    label="ปี พ.ศ."
                    outlined
                    dense
                    :disabled="importBusy"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-file-input
                    v-model="importFile"
                    accept=".csv"
                    label="ไฟล์ CSV รายชื่อผู้ย้าย"
                    outlined
                    dense
                    show-size
                    :disabled="importBusy"
                    @change="onImportFileChange"
                  ></v-file-input>
                </v-col>
              </v-row>

              <v-data-table
                v-if="importPreviewRows.length"
                :headers="importPreviewHeaders"
                :items="importPreviewRows"
                :loading="importBusy"
                dense
                disable-pagination
                hide-default-footer
                class="mb-4"
              >
                <template v-slot:item.status="{ item }">
                  <v-chip
                    x-small
                    dark
                    :color="importStatusColor(item.status)"
                  >
                    {{ importStatusText(item.status) }}
                  </v-chip>
                </template>
                <template v-slot:item.warnings="{ item }">
                  <div
                    v-for="(w, wi) in item.warnings"
                    :key="wi"
                    class="caption warning--text"
                  >
                    {{ w }}
                  </div>
                  <div v-if="item.message" class="caption error--text">
                    {{ item.message }}
                  </div>
                </template>
              </v-data-table>

              <v-alert v-if="importSummary" :type="importSummary.type" text dense>
                {{ importSummary.text }}
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="closeImportOfflineDialog" rounded>
                <v-icon dark>mdi-close</v-icon>ปิด
              </v-btn>
              <v-btn
                large
                color="info"
                rounded
                :loading="importBusy"
                :disabled="!importRows.length"
                @click.stop="runImport(true)"
              >
                <v-icon dark>mdi-magnify-scan</v-icon>&nbsp;ตรวจสอบก่อนนำเข้า
              </v-btn>
              <v-btn
                large
                color="success"
                rounded
                :loading="importBusy"
                :disabled="!importReadyToCommit"
                @click.stop="runImport(false)"
              >
                <v-icon dark>mdi-content-save-check</v-icon>&nbsp;ยืนยันนำเข้า
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import TransferenceManagebar from "../../components/admin/transferenceManagebar.vue";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { logSensitiveAccess } from "@/utils/sensitiveAccessLog";

export default {
  data() {
    return {
      stats: {
        overall: { total: 0, saved: 0, pending: 0, case_normal: 0, case_quality: 0, case_special: 0 },
        by_position: []
      },
      i: 0,
      value: 6,
      loading: false,
      ApiKey: "HRvec2021",
      approveDirectordialog: false,
      branch_s: [],
      tid_ref: [],
      valid: true,
      canceldialog: false,
      positiondialog: false,
      clear_dataDialog: false,
      times_select: "",
      years_select: "",
      type_name_position: "",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],
      name_position_s: [
        { text: "สายการสอนและสนับสนุนการสอน", value: "ครู" },
        { text: "สายงานบริหารสถานศึกษา", value: "บริหาร" }
      ],
      conditons_transfer_successs: [],
      editconditons_transfer_success: {},
      search: "",
      pagination: {},
      singleSelect: false,
      selected: [],
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "ยกลิก", align: "left", value: "actionCencel" },
        { text: "ครั้งที่", align: "left", value: "ctstime_s" },
        { text: "ปีที่", align: "center", value: "ctsyear_s" },
        { text: "สังกัดใหม่", align: "center", value: "college_name_new" },
        { text: "เลขที่", align: "center", value: "ctsid_position" },

        { text: "รหัสบัตรประชาชน", align: "center", value: "ctsid_card" },
        { text: "คำนำหน้าชื่อ", align: "center", value: "title_s" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "เลขที่", align: "left", value: "ctsid_postion_old" },
        { text: "สังกัดเดิม", align: "center", value: "college_name_old" },
        { text: "ตรวจสอบ", align: "left", value: "verify_flags" }
        /*  {
            text: "จำนวนผู้ขอย้ายรวม",
            align: "left",
            value: "personnel_num_all"
          }, */
        /*   { text: "วุฒิตรง(อันดับ)", align: "left", value: "personnel_num_ed" }, */
        /*    {
            text: "จำนวนผู้ขอย้ายในสาขาเดียวกัน",
            align: "left",
            value: "personnel_num_branch"
          }, */
        /*   { text: "ลำดับที่ขอย้าย", align: "left", value: "tlsequence_n" },
          {
            text: "อายุราชการในสถานศึกษาปัจจุบัน",
            align: "left",
            value: "age_app_cal"
          },
          { text: "อายุราชการตั้งแต่บรรจุ", align: "left", value: "age_app" },
          { text: "ช่วยปฏิบัติราชการ", align: "left", value: "service_status" },
          {
            text: "วิทยาลัยประสงค์รับย้าย",
            align: "left",
            value: "demand_college"
          },
          { text: "สรุป", align: "left", value: "summary_s" },
          { text: "ขาด/เกินเกณฑ์", align: "left", value: "total_s" } */
      ],
      rowsperpage: [
        25,
        50,
        100,
        {
          text: "All",
          value: -1
        }
      ],
      conditons_transfer_successs: [],
      updatepositions_condition: {},
      transference_locations: [],
      periods: [],
      transference_personnels_id_ref: [],
      conditons_transfer_successsSelect: [],
      man_powerss: [],
      man_powerCan: {},
      man_power_cancel: {},
      approveUpdate: {},

      // นำเข้าข้อมูลผู้ย้ายที่อนุมัตินอกระบบ (CSV import)
      importOfflineDialog: false,
      importTimeS: "",
      importYearS: "",
      importFile: null,
      importRows: [],
      importPreviewRows: [],
      importBusy: false,
      importLastDryRun: false,
      importSummary: null,
      importPreviewHeaders: [
        { text: "เลขบัตรประชาชน", align: "left", value: "id_card" },
        { text: "ชื่อ (จากระบบ)", align: "left", value: "name" },
        { text: "ตำแหน่ง", align: "left", value: "position_name" },
        { text: "เดิม", align: "left", value: "old_display" },
        { text: "ใหม่", align: "left", value: "new_display" },
        { text: "สถานะ", align: "center", value: "status" },
        { text: "หมายเหตุ", align: "left", value: "warnings" }
      ]
    };
  },
  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },
  async mounted() {
    await this.periodQuery();
    this.times_select = this.periods.period_times;
    this.years_select = this.periods.period_year;
    await this.conditons_transfer_successQueryAll();
    await this.loadStats();
    logSensitiveAccess(
      this.$http,
      "transference_manage_report",
      "view",
      `รอบ ${this.periods.period_times}/${this.periods.period_year}`
    );
  },
  methods: {
    async loadStats() {
      try {
        let result = await this.$http.post("transference_manage_stat.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.periods.period_times,
          manage_year_s: this.periods.period_year
        });
        if (result.data && result.data.overall) {
          this.stats = result.data;
        }
      } catch (e) {
        console.error("loadStats error", e);
      }
    },

    exportToExcel() {
      const filename = `รายงานย้ายผู้บริหาร_${this.periods.period_times}_${this.periods.period_year}.xlsx`;
      logSensitiveAccess(this.$http, "transference_manage_report", "export", filename);

      const exportData = this.conditons_transfer_successs.map((item, index) => ({
        ลำดับที่: index + 1,
        เลขบัตรประชาชน: item.ctsid_card,
        "ชื่อ-สกุล": `${item.title_s || ""}${item.frist_name || ""} ${item.last_name || ""}`,
        สังกัดเดิม: item.college_name_old,
        "จังหวัด (เดิม)": item.province_name_old,
        "วิทยฐานะ (เดิม)": item.rang_name,
        "เงินเดือน (เดิม)": item.salary_s,
        เลขที่ตำแหน่งเดิม: item.ctsid_postion_old,
        สังกัดใหม่: item.college_name_new,
        เลขที่ตำแหน่งใหม่: item.ctsid_position,
        "จังหวัด (ใหม่)": item.province_name_new,
        "วิทยฐานะ (ใหม่)": item.rang_name,
        "เงินเดือน (ใหม่)": item.salary_s
      }));

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "ย้ายผู้บริหาร");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      const data = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      });
      saveAs(data, filename);
    },

    async approveDirector() {
      this.approveDirectordialog = true;
    },
    async approveDirectorSubmit() {
      this.approveUpdate.ApiKey = this.ApiKey;
      this.approveUpdate.ctsname_position = "ผู้บริหาร";
      this.approveUpdate.ctstime_s = this.periods.period_times;
      this.approveUpdate.ctsyear_s = this.periods.period_year;
      let result = await this.$http.post(
        "transference_approve_allDirtor.php",
        this.approveUpdate
      );
      (result.data);
      if (result.status.data == true) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการบันทึกข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "บันทึกข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },
    async CencelMovementCut(id_ref) {
      let result_con = await this.$http.post("transference_personnel.php", {
        ApiKey: this.ApiKey,
        id_ref: id_ref
      });
      this.transference_personnels_id_ref = result_con.data;

      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        ctsid_ref: id_ref
      });
      this.conditons_transfer_successsSelect = result_cts.data;

      this.canceldialog = true;
    },
    async CencelMovement(id_ref) {
      let result_con = await this.$http.post("transference_personnel.php", {
        ApiKey: this.ApiKey,
        id_ref: id_ref
      });
      this.transference_personnels_id_ref = result_con.data;
      let result_man = await this.$http.post("man_power.php", {
        ApiKey: this.ApiKey,
        id_card: this.transference_personnels_id_ref.id_card
      });
      this.man_powerss = result_man.data;
      let result_cts = await this.$http.post("conditons_transfer_success.php", {
        ApiKey: this.ApiKey,
        ctsid_ref: id_ref
      });

      this.conditons_transfer_successsSelect = result_cts.data;
      this.canceldialog = true;
    },
    async cancelCutSubmit() {
      if (this.$refs.cancelform.validate()) {
        this.conditons_transfer_successsSelect.ApiKey = this.ApiKey;
        let result_cts = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successsSelect
        );

        if (result_cts.data.status == true) {
          this.snackbar.icon = "mdi-font-awesome";
          this.snackbar.color = "success";
          this.snackbar.text = "ยกเลิกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
          this.conditons_transfer_successQueryAll();
        } else {
          this.snackbar.icon = "mdi-close-network";
          this.snackbar.color = "red";
          this.snackbar.text = "ยกเลิกข้อมูลผิดพลาด";
          this.snackbar.show = true;
        }
        this.conditons_transfer_successQueryAll();
        this.canceldialog = false;
      }
    },
    async cancelSubmit() {
      if (this.$refs.cancelform.validate()) {
        this.man_powerCan.ApiKey = this.ApiKey;
        this.man_powerCan.status_booking = "";
        this.man_powerCan.id_position = this.man_powerss.id_position;
        this.man_power_cancel.ApiKey = this.ApiKey;
        this.man_power_cancel.id_position = this.conditons_transfer_successsSelect.ctsid_postion_old;
        if (this.man_powerss == false) {
        } else {
          let result_man = await this.$http.post(
            "man_power.update_process.php",
            this.man_powerCan
          );
        }
        let result_man_delete = await this.$http.post(
          "man_power.delete.php",
          this.man_power_cancel
        );

        this.conditons_transfer_successsSelect.ApiKey = this.ApiKey;
        let result_cts = await this.$http.post(
          "conditons_transfer_success.delete.php",
          this.conditons_transfer_successsSelect
        );

        if (
          result_cts.data.status == true &&
          result_man_delete.data.status == true
        ) {
          this.snackbar.icon = "mdi-font-awesome";
          this.snackbar.color = "success";
          this.snackbar.text = "ยกเลิกข้อมูลเรียบร้อย";
          this.snackbar.show = true;
          this.conditons_transfer_successQueryAll();
        } else {
          this.snackbar.icon = "mdi-close-network";
          this.snackbar.color = "red";
          this.snackbar.text = "ยกเลิกข้อมูลผิดพลาด";
          this.snackbar.show = true;
        }
        this.conditons_transfer_successQueryAll();
        this.canceldialog = false;
      }
    },
    async periodQuery() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "101"
      });
      this.periods = result_period.data;
    },
    async searchTimeYear() {
      this.loading = true;
      let result = await this.$http
        .post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.times_select,
          ctsyear_s: this.years_select
        })
        .finally(() => (this.loading = false));
      this.conditons_transfer_successs = result.data;
      await this.$http
        .post("transference_manage_stat.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.times_select,
          manage_year_s: this.years_select
        })
        .then(res => {
          if (res.data && res.data.overall) this.stats = res.data;
        });
    },
    async conditons_transfer_successQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctstime_s: this.periods.period_times,
          ctsyear_s: this.periods.period_year,
          ctsname_position: "ผู้บริหาร"
        })
        .finally(() => (this.loading = false));
      this.conditons_transfer_successs = result.data;
    },
    async clear_data() {
      this.clear_dataDialog = true;
    },

    // ==========================================
    // นำเข้าข้อมูลผู้ย้ายที่อนุมัตินอกระบบ (CSV import)
    // ==========================================
    openImportOfflineDialog() {
      this.importTimeS = "";
      this.importYearS = "";
      this.importFile = null;
      this.importRows = [];
      this.importPreviewRows = [];
      this.importBusy = false;
      this.importLastDryRun = false;
      this.importSummary = null;
      this.importOfflineDialog = true;
    },

    closeImportOfflineDialog() {
      this.importOfflineDialog = false;
    },

    onImportFileChange(file) {
      this.importRows = [];
      this.importPreviewRows = [];
      this.importLastDryRun = false;
      this.importSummary = null;
      if (!file) return;

      const reader = new FileReader();
      reader.onload = e => {
        try {
          const workbook = XLSX.read(e.target.result, { type: "binary" });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];
          // header:1 อ่านเป็น array-of-arrays ตามตำแหน่งคอลัมน์ — จำเป็นเพราะ CSV มีหัวคอลัมน์
          // "รหัสสถานศึกษา" ซ้ำกัน 2 ครั้ง (เดิม/ใหม่) การอ่านแบบ object-key ตามชื่อหัวคอลัมน์จะ
          // ทำให้ค่าที่ซ้ำชื่อกันถูกเขียนทับเหลือแค่คอลัมน์เดียว
          const raw = XLSX.utils.sheet_to_json(sheet, { header: 1, blankrows: false });
          const dataRows = raw.slice(1); // แถวแรกเป็นหัวตาราง

          this.importRows = dataRows
            .filter(r => r && String(r[1] || "").trim() !== "")
            .map(r => ({
              id_card: String(r[1] || "").trim(),
              name_csv: String(r[2] || "").trim(),
              id_position_old: String(r[3] || "").trim(),
              college_code_old: String(r[4] || "").trim(),
              college_name_old_csv: String(r[5] || "").trim(),
              college_code_new: String(r[6] || "").trim(),
              college_name_new_csv: String(r[7] || "").trim(),
              id_position_new: String(r[8] || "").trim()
            }));

          this.importPreviewRows = this.importRows.map(r => ({
            id_card: r.id_card,
            name: r.name_csv,
            position_name: "-",
            old_display: `${r.college_name_old_csv} (${r.id_position_old})`,
            new_display: `${r.college_name_new_csv} (${r.id_position_new})`,
            status: "pending",
            warnings: [],
            message: ""
          }));
        } catch (e) {
          this.snackbar = {
            show: true,
            color: "error",
            timeout: 5000,
            icon: "mdi-alert",
            text: "อ่านไฟล์ CSV ไม่สำเร็จ: " + e.message
          };
        }
      };
      reader.readAsBinaryString(file);
    },

    importStatusColor(status) {
      const map = {
        ready: "info",
        imported: "success",
        skipped_duplicate: "grey",
        error: "error",
        pending: "grey lighten-1"
      };
      return map[status] || "grey";
    },

    importStatusText(status) {
      const map = {
        ready: "พร้อมนำเข้า",
        imported: "นำเข้าแล้ว",
        skipped_duplicate: "ซ้ำ (ข้าม)",
        error: "ผิดพลาด",
        pending: "รอตรวจสอบ"
      };
      return map[status] || status;
    },

    async runImport(dryRun) {
      if (!this.importTimeS || !this.importYearS) {
        this.snackbar = {
          show: true,
          color: "error",
          timeout: 4000,
          icon: "mdi-alert",
          text: "กรุณาระบุครั้งที่และปี ก่อนดำเนินการ"
        };
        return;
      }
      if (!this.importRows.length) {
        this.snackbar = {
          show: true,
          color: "error",
          timeout: 4000,
          icon: "mdi-alert",
          text: "กรุณาเลือกไฟล์ CSV ก่อน"
        };
        return;
      }

      this.importBusy = true;
      this.importSummary = null;
      try {
        const result = await this.$http.post(
          "conditons_transfer_success.bulk_import_offline.php",
          {
            ApiKey: this.ApiKey,
            ctstime_s: this.importTimeS,
            ctsyear_s: this.importYearS,
            dry_run: dryRun,
            rows: this.importRows
          }
        );

        if (!result.data.status) {
          this.snackbar = {
            show: true,
            color: "error",
            timeout: 5000,
            icon: "mdi-alert",
            text: result.data.message || "เกิดข้อผิดพลาด"
          };
          this.importBusy = false;
          return;
        }

        const byCard = {};
        result.data.results.forEach(r => (byCard[r.id_card] = r));
        this.importPreviewRows = this.importRows.map(r => {
          const found = byCard[r.id_card] || {};
          return {
            id_card: r.id_card,
            name: found.name || r.name_csv,
            position_name: found.position_name || "-",
            old_display: `${r.college_name_old_csv} (${r.id_position_old})`,
            new_display: `${r.college_name_new_csv} (${r.id_position_new})`,
            status: found.status || "error",
            warnings: found.warnings || [],
            message: found.message || ""
          };
        });

        const counts = { ready: 0, imported: 0, skipped_duplicate: 0, error: 0 };
        result.data.results.forEach(r => {
          if (counts[r.status] !== undefined) counts[r.status]++;
        });

        if (dryRun) {
          this.importLastDryRun = true;
          this.importSummary = {
            type: counts.error > 0 ? "warning" : "info",
            text: `ตรวจสอบแล้ว ${this.importRows.length} รายการ — พร้อมนำเข้า ${counts.ready}, ซ้ำ ${counts.skipped_duplicate}, ผิดพลาด ${counts.error}`
          };
        } else {
          this.importLastDryRun = false;
          this.importSummary = {
            type: counts.error > 0 ? "warning" : "success",
            text: `นำเข้าเสร็จสิ้น — สำเร็จ ${counts.imported}, ข้าม (ซ้ำ) ${counts.skipped_duplicate}, ผิดพลาด ${counts.error}`
          };
          this.times_select = this.importTimeS;
          this.years_select = this.importYearS;
          await this.searchTimeYear();
        }
      } catch (e) {
        this.snackbar = {
          show: true,
          color: "error",
          timeout: 5000,
          icon: "mdi-alert",
          text: "เกิดข้อผิดพลาดในการเชื่อมต่อ"
        };
      } finally {
        this.importBusy = false;
      }
    },
    getColor(calories) {
      if (calories > 0) return "green";
      else return "";
    },
    row_classes(item) {
      if (item.ctsstatus_select == "transfer") {
        return "grey";
      }
    }
  },
  computed: {
    importReadyToCommit() {
      return this.importLastDryRun && this.importRows.length > 0 && !this.importBusy;
    },
    quotaCutCount() {
      return this.conditons_transfer_successs.filter(
        i => i.ctsstatus_select === "transfer"
      ).length;
    },
    retiringDestCount() {
      return this.conditons_transfer_successs.filter(
        i => i.dest_retire_status === "retiring_this_year"
      ).length;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    color() {
      return "green darken-4";
    },
    date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();
      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    }
  },
  components: { TransferenceManagebar }
};
</script>

<style scoped>
.orange {
  background-color: rgb(236, 194, 115);
}
</style>
